/*App.js*/

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { setCookie, getCookie } from './utils';

import connectlogo from "assets/img/btn_strava_connectwith_orange.png";
import SyncPanel from 'components/SyncPanel';

const login_api_url = process.env.REACT_APP_LOGIN_API_URL;
const resource_api_url = process.env.REACT_APP_RESOURCE_API_URL;
console.log('login_api_url', login_api_url); 
console.log('resource_api_url', resource_api_url);

function App() {
    const [showGoogleLogin, setShowGoogleLogin] = useState(true);
    const [user, setUser] = useState(null);
    const [strava_data, setStrava_data] = useState(null);
    const [listItems, setListItems] = useState(null);
    const [responseData, setResponseData] = useState({});
    const [loadingstatus, setLoadingstatus] = useState({});
    const [menu, setMenu] = useState(null);
    const [status, setStatus] = useState(null);
    const [units, setUnits] = useState('metric');

    const onClickHandler = useCallback(() => {
        setMenu(
          <div className="forge-status-msg">
            <i className="fas fa-circle-notch fa-spin" style={{ color: 'var(--forge-primary)', marginRight: '12px' }} />
            Authenticating with Google... please wait.
          </div>
        );
    }, []);

    const googleLoginButton = useMemo(() => {
        return (
            <GoogleLogin
                shape='pill'
                click_listener={() => onClickHandler()}
                onSuccess={credentialResponse => {
                    axios.post(`${login_api_url}/api/Login`, {
                        test: 'test'
                    }, {
                        headers: {
                            Authorization: credentialResponse.credential,
                        }
                    })
                        .then((res) => {
                            setCookie('stratava_token', res.data.token, { path: '/', expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365) });
                            setShowGoogleLogin(false);
                            checkToken();
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                }}
                onError={() => {
                    console.log('Login Failed');
                }}
                
            />
        );
    }, [login_api_url]);

    const stravaConectButton = useMemo(() => {
      return (
          <div
              style={{ cursor: 'pointer', display: 'inline-block', marginTop: '16px' }}
              onClick={() => {
                  const clientId = '13077';
                  const redirectUri = `${resource_api_url}/api/Store_Tokens`;
                  const scope = 'read,activity:read_all';
                  const state = getCookie('stratava_token');
                  const authUrl = `https://www.strava.com/oauth/authorize?state=${state}&client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&approval_prompt=force&scope=${scope}`;
                  window.open(authUrl, '_self');
              }}
          >
              <img src={connectlogo} alt="Connect with Strava" style={{ transition: 'all 250ms ease', borderRadius: 0 }} />
          </div>
      );
      }, []);

    function checkToken() {
        const cookieValue = getCookie('stratava_token');
        if (cookieValue) {
            axios.get(`${login_api_url}/api/CheckToken`, {
                headers: {
                    Authorization: cookieValue,
                }
            })
                .then(response => {
                    if (response.data.userid) {
                        setUser(response.data.userid);
                        setStatus(response.status);
                    }
                })
                .catch(error => {
                    setStatus(error.response.status);
                });
        } else {
            setStatus(401);
            setShowGoogleLogin(true);
        }
    }

    useEffect(() => {
        switch (status) {
            case 401:
                setMenu(
                  <div className="forge-auth-panel">
                    <div className="forge-subhead" style={{ marginBottom: '16px' }}>
                      <i className="fas fa-shield-alt" style={{ marginRight: '8px', color: 'var(--forge-primary)' }} />
                      AUTHENTICATION REQUIRED
                    </div>
                    <p style={{ color: 'var(--forge-text-muted)', fontFamily: 'var(--font-body)', fontSize: '0.9375rem', marginBottom: '20px' }}>
                      Sign in with Google to access your performance data.
                    </p>
                    {googleLoginButton}
                  </div>
                );
                break;
            case 202:
                setMenu(
                  <div className="forge-status-msg">
                    <i className="fas fa-circle-notch fa-spin" style={{ color: 'var(--forge-primary)', marginRight: '12px' }} />
                    Authenticated — checking Strava connection...
                  </div>
                );
                axios.get(`${resource_api_url}/api/User`, {
                    headers: {
                        Authorization: getCookie('stratava_token'),
                    }
                })
                    .then((res) => {
                        setStatus(res.status);
                    })
                    .catch((err) => {
                        setStatus(err.response.status);
                    });
                break;
            case 204:
                setMenu(
                  <div className="forge-status-msg">
                    <i className="fas fa-circle-notch fa-spin" style={{ color: 'var(--forge-primary)', marginRight: '12px' }} />
                    Loading your activities from Strava...
                  </div>
                );
                axios.get(`${resource_api_url}/api/Get_Activities`, {
                    headers: {
                        Authorization: getCookie('stratava_token'),
                    }
                })
                    .then((res) => {
                        if (res.status === 200) {
                            setStrava_data(res.data);
                        } else {
                            setStatus(res.status);
                        }
                    })
                    .catch((err) => {
                        setStatus(err.response.status);
                    });
                break;
            case 404:
                setMenu(
                  <div className="forge-auth-panel">
                    <div className="forge-subhead" style={{ marginBottom: '16px' }}>
                      <i className="fas fa-link" style={{ marginRight: '8px', color: 'var(--forge-primary)' }} />
                      CONNECT TO STRAVA
                    </div>
                    <p style={{ color: 'var(--forge-text-muted)', fontFamily: 'var(--font-body)', fontSize: '0.9375rem', marginBottom: '8px' }}>
                      Connect your Strava account to view advanced stats for your activities. We value your privacy — read our{' '}
                      <a href='/admin/Privacy' style={{ color: 'var(--forge-primary-bright)' }}>privacy policy</a> to learn what happens with your data.
                    </p>
                    <p style={{ color: 'var(--forge-text-dim)', fontFamily: 'var(--font-body)', fontSize: '0.8125rem', marginBottom: '16px' }}>
                      Note: You will be prompted to assign read permissions to your activity info, including private activities.
                    </p>
                    {stravaConectButton}
                  </div>
                );
                break;
            case 440:
                setMenu(
                  <div className="forge-auth-panel">
                    <div className="forge-subhead" style={{ marginBottom: '16px' }}>
                      <i className="fas fa-clock" style={{ marginRight: '8px', color: 'var(--forge-warning)' }} />
                      SESSION EXPIRED
                    </div>
                    <p style={{ color: 'var(--forge-text-muted)', fontFamily: 'var(--font-body)', fontSize: '0.9375rem', marginBottom: '20px' }}>
                      Your session has expired. Please sign in again.
                    </p>
                    {googleLoginButton}
                  </div>
                );
                setShowGoogleLogin(true);
                break;
            default:
                console.log('Unknown status');
                checkToken();
                break;
        }
    }, [status, googleLoginButton]);

    const handleButtonClick = (entry) => {
        setLoadingstatus(prevStatus => ({
            ...prevStatus,
            [entry.id]: 'loading'
        }));

        setTimeout(() => {
            axios.post(`${resource_api_url}/api/Get_Activity`, {
                activity: entry
            }, {
                headers: {
                    Authorization: getCookie('stratava_token'),
                }
            })
                .then((res) => {
                    setLoadingstatus(prevStatus => ({
                        ...prevStatus,
                        [entry.id]: 'loaded'
                    }));
                    setResponseData(prevData => ({
                        ...prevData,
                        [entry.id]: res.data
                    }));
                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        setShowGoogleLogin(true);
                    }
                });
        }, 100);
    };

    const formatPace = (paceInMinutes) => {
        const minutes = Math.floor(paceInMinutes);
        const seconds = Math.round((paceInMinutes - minutes) * 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        const hours = date.getHours();
        const mins = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const h = hours % 12 || 12;
        return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()} · ${h}:${mins} ${ampm}`;
    };

    const formatDistance = (meters) => {
        if (units === 'metric') {
            return `${(meters / 1000).toFixed(2)} km`;
        }
        return `${(meters / 1609.34).toFixed(2)} mi`;
    };
    
    useEffect(() => {
        if (strava_data) {
            const listItems = strava_data.map(entry => (
              entry.distance > 0 && (
                <div className="forge-activity forge-animate-in" key={entry.id}>
                  {/* Activity Header */}
                  <div className="forge-activity-header">
                    <div style={{ flex: 1 }}>
                      <div className="forge-activity-date">
                        <i className="fas fa-calendar-alt" style={{ marginRight: '6px', opacity: 0.5 }} />
                        {formatDate(entry.start_date)}
                      </div>
                      <div className="forge-activity-name">{entry.name}</div>
                      <div className="forge-activity-meta">
                        <span>
                          <i className="fas fa-road" style={{ marginRight: '4px', color: 'var(--forge-primary)', fontSize: '0.7rem' }} />
                          <strong>{formatDistance(entry.distance)}</strong>
                        </span>
                        <span>
                          <i className="fas fa-clock" style={{ marginRight: '4px', color: 'var(--forge-primary)', fontSize: '0.7rem' }} />
                          <strong>{Math.round(entry.elapsed_time / 60)}</strong> min
                        </span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                      <a 
                        className="Stravalink" 
                        href={`https://www.strava.com/activities/${entry.id}`} 
                        target="_blank" 
                        rel="noreferrer"
                        style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                      >
                        <i className="fas fa-external-link-alt" style={{ fontSize: '0.625rem' }} />
                        View on Strava
                      </a>
                    </div>
                  </div>

                  {/* Analyze Button */}
                  {loadingstatus[entry.id] !== 'loaded' && (
                    <button 
                      onClick={() => handleButtonClick(entry)}
                      disabled={loadingstatus[entry.id] === 'loading'}
                      style={loadingstatus[entry.id] === 'loading' ? { opacity: 0.6, cursor: 'wait' } : {}}
                    >
                      {loadingstatus[entry.id] === 'loading' ? (
                        <><i className="fas fa-circle-notch fa-spin" style={{ marginRight: '8px' }} />ANALYZING...</>
                      ) : (
                        <><i className="fas fa-bolt" style={{ marginRight: '8px' }} />ANALYZE</>
                      )}
                    </button>
                  )}

                  {/* Metrics Display */}
                  {responseData[entry.id] && (
                    <div className="forge-metrics">
                      {/* Average Speed */}
                      <div className="forge-metric-card">
                        <div className="metric-label">AVG SPEED</div>
                        <div className="metric-value">
                          {units === 'metric' 
                            ? (responseData[entry.id]['avg'] * 3.6).toFixed(1)
                            : (responseData[entry.id]['avg'] * 3.6 / 1.60934).toFixed(1)}
                        </div>
                        <div className="metric-unit">{units === 'metric' ? 'km/h' : 'mph'}</div>
                        <div className="metric-secondary">
                          pace: {units === 'metric'
                            ? `${formatPace(60 / (responseData[entry.id]['avg'] * 3.6))} /km`
                            : `${formatPace(60 / (responseData[entry.id]['avg'] * 3.6 / 1.60934))} /mi`}
                        </div>
                      </div>

                      {/* Cruising Speed (50th) */}
                      <div className="forge-metric-card">
                        <div className="metric-label">CRUISING SPEED</div>
                        <div className="metric-value">
                          {units === 'metric'
                            ? responseData[entry.id]['50% Qrt Speed']
                            : (responseData[entry.id]['50% Qrt Speed'] / 1.60934).toFixed(1)}
                        </div>
                        <div className="metric-unit">{units === 'metric' ? 'km/h' : 'mph'} · 50TH PERCENTILE</div>
                        <div className="metric-secondary">
                          pace: {units === 'metric'
                            ? `${formatPace(60 / responseData[entry.id]['50% Qrt Speed'])} /km`
                            : `${formatPace(60 / (responseData[entry.id]['50% Qrt Speed'] / 1.60934))} /mi`}
                        </div>
                      </div>

                      {/* Power Zone (75th) */}
                      <div className="forge-metric-card" style={{ borderLeftColor: 'var(--forge-secondary)' }}>
                        <div className="metric-label">POWER ZONE</div>
                        <div className="metric-value" style={{ color: 'var(--forge-secondary)' }}>
                          {units === 'metric'
                            ? responseData[entry.id]['75% Qrt Speed']
                            : (responseData[entry.id]['75% Qrt Speed'] / 1.60934).toFixed(1)}
                        </div>
                        <div className="metric-unit">{units === 'metric' ? 'km/h' : 'mph'} · 75TH PERCENTILE</div>
                        <div className="metric-secondary">
                          pace: {units === 'metric'
                            ? `${formatPace(60 / responseData[entry.id]['75% Qrt Speed'])} /km`
                            : `${formatPace(60 / (responseData[entry.id]['75% Qrt Speed'] / 1.60934))} /mi`}
                        </div>
                      </div>

                      {/* Best 10 min */}
                      {responseData[entry.id]['Best 10 min Speed']['time'] > 0 && (
                        <div className="forge-metric-card">
                          <div className="metric-label">BEST 10 MIN</div>
                          <div className="metric-value">
                            {units === 'metric'
                              ? responseData[entry.id]['Best 10 min Speed'].speed
                              : (responseData[entry.id]['Best 10 min Speed'].speed / 1.60934).toFixed(1)}
                          </div>
                          <div className="metric-unit">{units === 'metric' ? 'km/h' : 'mph'}</div>
                          <div className="metric-secondary">
                            pace: {units === 'metric'
                              ? `${formatPace(60 / responseData[entry.id]['Best 10 min Speed'].speed)} /km`
                              : `${formatPace(60 / (responseData[entry.id]['Best 10 min Speed'].speed / 1.60934))} /mi`}
                          </div>
                          <div className="metric-secondary">
                            {responseData[entry.id]['Best 10 min Speed'].time} min · {responseData[entry.id]['Best 10 min Speed'].distance} km
                          </div>
                        </div>
                      )}

                      {/* Best 20 min */}
                      {responseData[entry.id]['Best 20 min Speed']['time'] > 0 && (
                        <div className="forge-metric-card">
                          <div className="metric-label">BEST 20 MIN</div>
                          <div className="metric-value">
                            {units === 'metric'
                              ? responseData[entry.id]['Best 20 min Speed'].speed
                              : (responseData[entry.id]['Best 20 min Speed'].speed / 1.60934).toFixed(1)}
                          </div>
                          <div className="metric-unit">{units === 'metric' ? 'km/h' : 'mph'}</div>
                          <div className="metric-secondary">
                            pace: {units === 'metric'
                              ? `${formatPace(60 / responseData[entry.id]['Best 20 min Speed'].speed)} /km`
                              : `${formatPace(60 / (responseData[entry.id]['Best 20 min Speed'].speed / 1.60934))} /mi`}
                          </div>
                          <div className="metric-secondary">
                            {responseData[entry.id]['Best 20 min Speed'].time} min · {responseData[entry.id]['Best 20 min Speed'].distance} km
                          </div>
                        </div>
                      )}

                      {/* Best 30 min */}
                      {responseData[entry.id]['Best 30 min Speed']['time'] > 0 && (
                        <div className="forge-metric-card">
                          <div className="metric-label">BEST 30 MIN</div>
                          <div className="metric-value">
                            {units === 'metric'
                              ? responseData[entry.id]['Best 30 min Speed'].speed
                              : (responseData[entry.id]['Best 30 min Speed'].speed / 1.60934).toFixed(1)}
                          </div>
                          <div className="metric-unit">{units === 'metric' ? 'km/h' : 'mph'}</div>
                          <div className="metric-secondary">
                            pace: {units === 'metric'
                              ? `${formatPace(60 / responseData[entry.id]['Best 30 min Speed'].speed)} /km`
                              : `${formatPace(60 / (responseData[entry.id]['Best 30 min Speed'].speed / 1.60934))} /mi`}
                          </div>
                          <div className="metric-secondary">
                            {responseData[entry.id]['Best 30 min Speed'].time} min · {units === 'metric' 
                              ? `${responseData[entry.id]['Best 30 min Speed'].distance} km` 
                              : `${(responseData[entry.id]['Best 30 min Speed'].distance / 1.60934).toFixed(2)} mi`}
                          </div>
                        </div>
                      )}

                      {/* Most Consistent 20 min */}
                      {responseData[entry.id]['Most Consistent 20 min'] && (
                        <div className="forge-metric-card" style={{ borderLeftColor: 'var(--forge-info)' }}>
                          <div className="metric-label">MOST CONSISTENT 20 MIN</div>
                          <div className="metric-value" style={{ color: 'var(--forge-info)' }}>
                            {units === 'metric'
                              ? formatPace(60 / responseData[entry.id]['Most Consistent 20 min'].speed)
                              : formatPace(60 / (responseData[entry.id]['Most Consistent 20 min'].speed / 1.60934))}
                          </div>
                          <div className="metric-unit">{units === 'metric' ? '/km' : '/mi'} avg pace</div>
                          <div className="metric-secondary">
                            ±{units === 'metric'
                              ? Math.round(responseData[entry.id]['Most Consistent 20 min'].std_dev * 3600 / Math.pow(responseData[entry.id]['Most Consistent 20 min'].speed, 2))
                              : Math.round(responseData[entry.id]['Most Consistent 20 min'].std_dev * 3600 * 1.60934 / Math.pow(responseData[entry.id]['Most Consistent 20 min'].speed, 2))}s/{units === 'metric' ? 'km' : 'mi'} pace var
                          </div>
                          <div className="metric-secondary">
                            @ {responseData[entry.id]['Most Consistent 20 min'].time} min · {units === 'metric'
                              ? `${responseData[entry.id]['Most Consistent 20 min'].distance} km`
                              : `${(responseData[entry.id]['Most Consistent 20 min'].distance / 1.60934).toFixed(2)} mi`}
                          </div>
                        </div>
                      )}

                      {/* Most Consistent 30 min */}
                      {responseData[entry.id]['Most Consistent 30 min'] && (
                        <div className="forge-metric-card" style={{ borderLeftColor: 'var(--forge-info)' }}>
                          <div className="metric-label">MOST CONSISTENT 30 MIN</div>
                          <div className="metric-value" style={{ color: 'var(--forge-info)' }}>
                            {units === 'metric'
                              ? formatPace(60 / responseData[entry.id]['Most Consistent 30 min'].speed)
                              : formatPace(60 / (responseData[entry.id]['Most Consistent 30 min'].speed / 1.60934))}
                          </div>
                          <div className="metric-unit">{units === 'metric' ? '/km' : '/mi'} avg pace</div>
                          <div className="metric-secondary">
                            ±{units === 'metric'
                              ? Math.round(responseData[entry.id]['Most Consistent 30 min'].std_dev * 3600 / Math.pow(responseData[entry.id]['Most Consistent 30 min'].speed, 2))
                              : Math.round(responseData[entry.id]['Most Consistent 30 min'].std_dev * 3600 * 1.60934 / Math.pow(responseData[entry.id]['Most Consistent 30 min'].speed, 2))}s/{units === 'metric' ? 'km' : 'mi'} pace var
                          </div>
                          <div className="metric-secondary">
                            @ {responseData[entry.id]['Most Consistent 30 min'].time} min · {units === 'metric'
                              ? `${responseData[entry.id]['Most Consistent 30 min'].distance} km`
                              : `${(responseData[entry.id]['Most Consistent 30 min'].distance / 1.60934).toFixed(2)} mi`}
                          </div>
                        </div>
                      )}

                      {/* Full Run Consistency */}
                      {responseData[entry.id]['Full Run Consistency'] && (
                        <div className="forge-metric-card" style={{ borderLeftColor: 'var(--forge-info)' }}>
                          <div className="metric-label">FULL RUN CONSISTENCY</div>
                          <div className="metric-value" style={{ color: 'var(--forge-info)' }}>
                            ±{units === 'metric'
                              ? Math.round(responseData[entry.id]['Full Run Consistency'].std_dev * 3600 / Math.pow(responseData[entry.id]['Full Run Consistency'].speed, 2))
                              : Math.round(responseData[entry.id]['Full Run Consistency'].std_dev * 3600 * 1.60934 / Math.pow(responseData[entry.id]['Full Run Consistency'].speed, 2))}
                          </div>
                          <div className="metric-unit">s/{units === 'metric' ? 'km' : 'mi'} pace var</div>
                          <div className="metric-secondary">
                            avg {units === 'metric'
                              ? `${formatPace(60 / responseData[entry.id]['Full Run Consistency'].speed)} /km`
                              : `${formatPace(60 / (responseData[entry.id]['Full Run Consistency'].speed / 1.60934))} /mi`}
                          </div>
                          <div className="metric-secondary">lower = more consistent pace</div>
                        </div>
                      )}

                      {/* Heart Rate Recovery */}
                      <div className="forge-metric-card" style={{ borderLeftColor: 'var(--forge-danger)' }}>
                        <div className="metric-label">IRON RECOVERY SCORE</div>
                        <div className="metric-value" style={{ color: 'var(--forge-danger)' }}>
                          {responseData[entry.id]['HRD']['largest_drop'].toFixed(1)}
                        </div>
                        <div className="metric-unit">BPM DROP</div>
                        <div className="metric-secondary">
                          @ {(responseData[entry.id]['HRD']['time_bucket']/60).toFixed(1)} min post-exercise
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )
            ));
            setListItems(listItems);
        }
    }, [strava_data, responseData, loadingstatus, units]);

    return (
        <div className="content">
          {/* Page Header */}
          <div style={{ marginBottom: '24px' }}>
            <div className="forge-headline" style={{ marginBottom: '4px' }}>
              <i className="fas fa-chart-bar" style={{ marginRight: '10px', color: 'var(--forge-primary)', fontSize: '1.25rem' }} />
              ACTIVITIES
            </div>
            {!showGoogleLogin && user && (
              <div className="forge-label" style={{ opacity: 0.6 }}>
                <i className="fas fa-user" style={{ marginRight: '6px' }} />
                {user}
              </div>
            )}
          </div>

          {/* Auth/Status Messages */}
          {menu}

          {/* Unit Settings */}
          <div className="settings">
            <h4>
              <i className="fas fa-cog" style={{ marginRight: '6px' }} />
              Units
            </h4>
            <ul>
              <li>
                <label>
                  <input
                    type="radio"
                    value="metric"
                    checked={units === 'metric'}
                    onChange={() => setUnits('metric')}
                  />
                  {' '}Metric (km/h)
                </label>
              </li>
              <li>
                <label>
                  <input
                    type="radio"
                    value="imperial"
                    checked={units === 'imperial'}
                    onChange={() => setUnits('imperial')}
                  />
                  {' '}Imperial (mph)
                </label>
              </li>
            </ul>
          </div>

          {/* Save activities to storage (only once Strava is connected) */}
          {strava_data && <SyncPanel />}

          {/* Activity List */}
          {listItems && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
              {listItems}
            </div>
          )}
        </div>
    );
}

export default App;
